import request from "@/utils/request";
import Qs from "qs";

const api = {
  findPage: "/foreignapi/jResources/findPage",
  save: "/openapi/jResources/save",
  del: "/openapi/jResources/deletesTask",
  download: "/foreignapi/jResources/download",
  preview: "/openapi/jResources/findUrlByAttachment",
  inquire: "/foreignapi/jTypes/treesById",
  inquireNotLog: "/foreignapi/jTypes/treesByIdf",
  findOne: "openapi/jResources/findOne"
};

/**
 * 分页查询
 * @param parameter
 * @returns {*}
 */
export function findPage(parameter) {
  return request({
    url: api.findPage,
    method: "get",
    params: parameter
  });
}

/**
 * 保存/编辑
 * @param {*} parameter
 */
export function save(parameter) {
  return request({
    url: api.save,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

/**
 * 下载
 * @param {*} parameter
 */
export function download(parameter) {
  return request({
    url: api.download,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

/**
 * 删除
 * @param {*} parameter
 */
export function del(parameter) {
  return request({
    url: api.del,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

/**
 * 文件转pdf预览
 * @param {*} parameter
 */
export function preview(parameter) {
  return request({
    url: api.preview,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

/**
 * 根据父级id查询
 * @param {*} parameter
 */
export function inquire(parameter) {
  return request({
    url: api.inquire,
    method: "get",
    params: parameter
  });
}

/**
 * 根据父级id查询（未登录）
 * @param {*} parameter
 */
export function inquireNotLog(parameter) {
  return request({
    url: api.inquireNotLog,
    method: "get",
    params: parameter
  });
}

/**
 * 根据父级id查询（未登录）
 * @param {*} parameter
 */
export function findOne(parameter) {
  return request({
    url: api.findOne,
    method: "get",
    params: parameter
  });
}
